module.exports = __webpack_public_path__ + "v4assets/journeys-screenshot-dark.87ff42ae1992cd77c487a12c7ebf38bf.png";